export default "__VITE_ASSET__ce36306f__$_?nuxt_component=async__"